import { render, staticRenderFns } from "./SessionEnded.vue?vue&type=template&id=3bc6a947&"
import script from "./SessionEnded.vue?vue&type=script&lang=ts&"
export * from "./SessionEnded.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports